/* ==========================================================================
   NIALL — interaktivni efekti
   assets/niall-effects.js  (učitaj na dnu theme.liquid pre </body>:
   <script src="{{ 'niall-effects.js' | asset_url }}" defer></script>)

   Efekti se uključuju automatski preko data-atributa / klasa:
   - Hover tilt:        dodaj class="niall-tilt" na karticu proizvoda
   - Zoom na reljef:    dodaj class="niall-zoom" na .niall-zoom > img
   - Scroll reveal:     dodaj class="niall-reveal" na bilo koju sekciju
   - Parallax:          dodaj class="niall-parallax" na sliku pozadine
   - Exit popup:        automatski (element #niall-exit-popup u snippetu)
   - Scratch popup:     automatski (element #niall-scratch-popup u snippetu)
   ========================================================================== */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- 0. PROZIRNI HEADER preko hero sekcije (samo stranice sa .nvh) ---- */
  if (document.querySelector('.nvh')) {
    document.body.classList.add('niall-hero-page');
  }

  /* ---- 0z. HORIZONTALNI SCROLL CUE — [data-hscroll] dobija strelicu „ima još desno" ---- */
  document.querySelectorAll('[data-hscroll]').forEach(function (el) {
    var wrap = document.createElement('div');
    wrap.className = 'n-hscroll';
    el.parentNode.insertBefore(wrap, el);
    wrap.appendChild(el);
    var cue = document.createElement('button');
    cue.type = 'button';
    cue.className = 'n-hscroll__cue';
    cue.setAttribute('aria-label', 'Pomeri desno');
    cue.innerHTML = '<i class="ti ti-arrow-right"></i>';
    wrap.appendChild(cue);
    function update() {
      var scrollable = el.scrollWidth > el.clientWidth + 8;
      wrap.classList.toggle('is-static', !scrollable);
      wrap.classList.toggle('is-end', scrollable && el.scrollLeft + el.clientWidth >= el.scrollWidth - 8);
    }
    cue.addEventListener('click', function () {
      el.scrollBy({ left: Math.round(el.clientWidth * 0.7), behavior: 'smooth' });
    });
    el.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if (window.ResizeObserver) new ResizeObserver(update).observe(el);
    update();
  });

  /* ---- 0a. STAGGER REVEAL — .niall-reveal-stagger > deca ulaze jedno po jedno ---- */
  if (!reducedMotion && 'IntersectionObserver' in window) {
    document.querySelectorAll('.niall-reveal-stagger').forEach(function (group) {
      var kids = Array.prototype.slice.call(group.children);
      kids.forEach(function (el, i) {
        el.style.opacity = '0';
        el.style.transform = 'translateY(28px)';
        el.style.transition = 'opacity .7s cubic-bezier(.22,1,.36,1) ' + (i * 0.09) + 's, transform .7s cubic-bezier(.22,1,.36,1) ' + (i * 0.09) + 's';
      });
      var gio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            kids.forEach(function (el) {
              el.style.opacity = '1';
              el.style.transform = 'translateY(0)';
            });
            gio.unobserve(en.target);
          }
        });
      }, { threshold: 0.12 });
      gio.observe(group);
    });
  }

  /* ---- 0b. COUNT-UP — [data-countup] broji od 0 do vrednosti u tekstu ---- */
  if ('IntersectionObserver' in window) {
    document.querySelectorAll('[data-countup]').forEach(function (el) {
      var raw = el.textContent.trim();
      var m = raw.match(/^([^0-9]*)([\d.,]+)(.*)$/);
      if (!m) return; // nema cifara (npr. ★★★★★) — preskoči
      var prefix = m[1], suffix = m[3], numRaw = m[2];
      // "1.240" = hiljade (separator + tačno 3 cifre), "4.9" = decimalni broj
      var decMatch = numRaw.match(/^(\d+)[.,](\d{1,2})$/);
      var decimals = decMatch ? decMatch[2].length : 0;
      var decSep = decMatch ? numRaw.replace(/\d/g, '') : '';
      var target = decMatch ? parseFloat(decMatch[1] + '.' + decMatch[2]) : parseInt(numRaw.replace(/[.,]/g, ''), 10);
      if (isNaN(target)) return;
      var useSep = !decMatch && /[.,]/.test(numRaw);
      function fmt(n) {
        if (decimals) return n.toFixed(decimals).replace('.', decSep);
        return useSep ? Math.round(n).toLocaleString('sr-RS') : String(Math.round(n));
      }
      if (reducedMotion) return;
      el.textContent = prefix + fmt(0) + suffix;
      var cio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          cio.unobserve(el);
          var t0 = null, dur = 1400;
          function tick(ts) {
            if (!t0) t0 = ts;
            var p = Math.min(1, (ts - t0) / dur);
            var eased = 1 - Math.pow(1 - p, 3);
            el.textContent = prefix + fmt(target * eased) + suffix;
            if (p < 1) requestAnimationFrame(tick);
          }
          requestAnimationFrame(tick);
        });
      }, { threshold: 0.4 });
      cio.observe(el);
    });
  }

  /* ---- 1. HOVER TILT ---- */
  document.querySelectorAll('.niall-tilt').forEach(function (card) {
    card.style.transition = 'transform .2s ease';
    card.style.transformStyle = 'preserve-3d';
    card.addEventListener('mousemove', function (e) {
      var r = card.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5;
      var y = (e.clientY - r.top) / r.height - 0.5;
      card.style.transform = 'perspective(1000px) rotateY(' + (x * 8) + 'deg) rotateX(' + (-y * 8) + 'deg) translateZ(8px)';
    });
    card.addEventListener('mouseleave', function () {
      card.style.transform = 'perspective(1000px) rotateY(0) rotateX(0) translateZ(0)';
    });
  });

  /* ---- 2. ZOOM NA RELJEF ---- */
  document.querySelectorAll('.niall-zoom').forEach(function (box) {
    var img = box.querySelector('img');
    if (!img) return;
    box.style.overflow = 'hidden';
    box.style.cursor = 'zoom-in';
    img.style.transition = 'transform .3s ease';
    box.addEventListener('mousemove', function (e) {
      var r = box.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width * 100;
      var y = (e.clientY - r.top) / r.height * 100;
      img.style.transformOrigin = x + '% ' + y + '%';
      img.style.transform = 'scale(2)';
    });
    box.addEventListener('mouseleave', function () { img.style.transform = 'scale(1)'; });
  });

  /* ---- 3. SCROLL REVEAL ---- */
  var reveals = document.querySelectorAll('.niall-reveal');
  if (reveals.length && !reducedMotion && 'IntersectionObserver' in window) {
    reveals.forEach(function (el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(24px)';
      el.style.transition = 'opacity .7s ease, transform .7s ease';
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.style.opacity = '1';
          en.target.style.transform = 'translateY(0)';
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.15 });
    reveals.forEach(function (el) { io.observe(el); });
  }

  /* ---- 4. PARALLAX ---- */
  var parallax = document.querySelectorAll('.niall-parallax');
  if (parallax.length) {
    window.addEventListener('scroll', function () {
      var sy = window.pageYOffset;
      parallax.forEach(function (el) {
        var speed = parseFloat(el.getAttribute('data-speed')) || 0.3;
        var r = el.getBoundingClientRect();
        var offset = (r.top + sy) - sy;
        el.style.transform = 'translateY(' + (offset * speed * -0.1) + 'px)';
      });
    }, { passive: true });
  }

  /* ---- 5. EXIT-INTENT POPUP ---- */
  var exitPopup = document.getElementById('niall-exit-popup');
  if (exitPopup) {
    var exitShown = false;
    var seen = false;
    try { seen = sessionStorage.getItem('niall_exit_seen') === '1'; } catch (e) {}
    if (!seen) {
      document.addEventListener('mouseout', function (e) {
        if (!exitShown && e.clientY < 10 && !e.relatedTarget) {
          exitPopup.style.display = 'flex';
          exitShown = true;
          try { sessionStorage.setItem('niall_exit_seen', '1'); } catch (er) {}
        }
      });
    }
    exitPopup.querySelectorAll('[data-niall-close]').forEach(function (b) {
      b.addEventListener('click', function () { exitPopup.style.display = 'none'; });
    });
    exitPopup.addEventListener('click', function (e) { if (e.target === exitPopup) exitPopup.style.display = 'none'; });

    // AJAX prijava — bez reload-a, potvrda odmah u popupu
    var exitForm = exitPopup.querySelector('#niall-exit-form');
    if (exitForm) {
      exitForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = exitForm.querySelector('button[type="submit"]');
        if (btn) { btn.disabled = true; btn.textContent = '...'; }
        fetch(exitForm.getAttribute('action'), { method: 'POST', body: new FormData(exitForm) })
          .then(function () {
            var row = exitForm.querySelector('.niall-pop__form');
            if (row) row.outerHTML = '<div class="niall-pop__ok">✓ Prijavljen si — kod ti stiže na email.</div>';
            try { localStorage.setItem('niall_exit_done', '1'); } catch (er) {}
          })
          .catch(function () {
            if (btn) { btn.disabled = false; btn.textContent = 'UZMI KOD'; }
          });
      });
    }
  }

})();

/* ---- CART DRAWER UPSELL: „Dopuni porudžbinu" dugmad (delegirano — sadržaj drawera se re-renderuje) ---- */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ncd-add]');
    if (!btn) return;
    var drawer = document.querySelector('cart-drawer');
    var id = parseInt(btn.getAttribute('data-ncd-add'));
    btn.disabled = true; btn.textContent = '...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); }).then(function (json) {
      if (drawer && typeof drawer.renderContents === 'function' && json.sections) { drawer.classList.remove('is-empty'); drawer.renderContents(json); }
      else window.location.reload();
    }).catch(function () { btn.disabled = false; btn.textContent = 'Dodaj'; });
  });
})();
